<template>
  <div>
    <Breadcrumb :items="breadcrumbs" />
    <div class="container">
      <div class="banner banner-events block block-shadow">
        <div class="row" v-if="event">
          <div class="col-lg-6">
            <img
              :src="event.featuredImage != null ? event.featuredImage : featImg"
              :alt="event.name"
              class="banner__feat"
            />
          </div>
          <div class="col-lg-6 banner__content">
            <div class="event-loader" v-if="isLoading">
              <Spinner :theme="primary" :size="'medium'" />
            </div>
            <template v-else>
              <h2>{{ event.name }}</h2>
              <span>
                {{
                  parseDate(event.startDate, "YYYY-MM-DD") ==
                  parseDate(event.endDate, "YYYY-MM-DD")
                    ? parseDate(event.startDate, "MMM, DD. YYYY hh:mm A") +
                      " - " +
                      parseDate(event.endDate, "hh:mm A")
                    : parseDate(event.startDate, "MMM, DD. YYYY hh:mm A") +
                      " - " +
                      parseDate(event.endDate, "MMM, DD. YYYY hh:mm A")
                }}
              </span>
              <p class="ql-editor" v-html="event.description">
                {{ event.description }}
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import moment from "@/helpers/moment";
import Spinner from "@/components/Spinner";

export default {
  name: "viewEvent",
  props: {
    featImg: {
      type: String,
      default: require("@/assets/media/backgrounds/default.jpg")
    }
  },
  components: {
    Breadcrumb,
    Spinner
  },
  data: () => ({
    breadcrumbs: [
      { path: "/user", name: "Home" },
      { path: "", name: "Events" }
    ],
    isLoading: true
  }),
  computed: {
    event() {
      return this.$store.state.concierge.eventsList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  watch: {
    event: function(val) {
      this.breadcrumbs = [
        { path: "/user", name: "Home" },
        { path: "/user/events", name: "Events" },
        { path: "", name: val.name }
      ];
    }
  },
  async created() {
    let eventId = this.$route.params.id;
    await this.$store.dispatch("fetchRecentEvents", `events/${eventId}`);
    this.isLoading = false;
  },
  methods: {
    parseDate(date, format) {
      return moment(date).format(format);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.banner {
  margin-bottom: 40px;
  .banner__content {
    font-family: "Gotham";
    padding: 50px 60px;
    h5 {
      color: $gray-500;
      font-family: "Gotham";
      font-size: $font-size-lg;
      font-weight: 500;
      margin-bottom: 15px;
    }
    h2 {
      color: $gray-900;
      font-size: $pbf-height-sm;
      font-weight: 500;
      margin-bottom: 10px;
    }
    p {
      color: $gray-700;
      font-size: $font-size-md;
      margin: 15px 0 65px;
      word-break: break-word;
      & /deep/ img {
        color: blue;
        max-width: 100%;
      }
    }
    span {
      color: $gray-500;
      font-size: $font-size-sm;
    }
    .ql-editor {
      padding: 0px;
      & /deep/ a {
        color: var(--primary, $brand-primary);
      }
    }
  }
  .banner__feat {
    object-fit: cover;
    height: 100%;
    max-height: 300px;
    width: 100%;
  }
}
</style>
